import { ActionBox } from "./ActionBox";
import { pwaAssets } from "assets/cdn";
import { Column, Container, Icon, SubTitle, Title } from "./styles";
import { useImagePath } from "hooks/useImagePath";

export interface Props {
	onClick: () => void;
}

const MegaMenuView = ({ onClick }: Props) => {
	const { getImage } = useImagePath("cdn");
	const bannerIcon = getImage(pwaAssets.pushBannerIcon);
	const info = {
		title: "Enable notifications",
		subtitle: "Get notifications when rewards are ready!"
	};

	return (
		<Container>
			<Icon src={bannerIcon} />
			<Column>
				<Title>{info.title}</Title>
				<SubTitle>{info.subtitle}</SubTitle>
			</Column>
			<Column
				style={{
					justifyContent: "flex-end",
					height: "100%"
				}}
			>
				<ActionBox onClick={onClick} />
			</Column>
		</Container>
	);
};

export default MegaMenuView;
